import { Button, Checkbox, ComponentType, LoadingButton, ModalBodyExtras, useModal } from '@gcl/react-core';
import * as React from 'react';
import { ReactNode } from 'react';
import './confirmation.scss';

export interface IUseConfirmationModalProps {
  title?: string;
  content: string | ReactNode;
  onConfirm: () => void;
  onCancel?: () => void;
  modalId?: string;
  isShowDoNotShowAgain?: boolean;
  isShowCancelBtn?: boolean;
}

export const useConfirmationModal = ({
  title,
  content,
  onConfirm,
  onCancel,
  modalId,
  isShowDoNotShowAgain,
  isShowCancelBtn = true,
}: IUseConfirmationModalProps) => {
  const { openPortal: openModal, isOpen, closePortal, renderModal } = useModal();

  const [isSelectedModalNotShowAgain, setIsSelectModalNotShowAgain] = React.useState(false);

  const openPortal = React.useCallback(
    (
      e?:
        | React.MouseEventHandler
        | React.MouseEvent
        | undefined
        | {
            currentTarget: boolean;
          },
    ) => {
      setIsSelectModalNotShowAgain(false);
      if (modalId) {
        const doNotShowAgain = localStorage.getItem(modalId);
        if (doNotShowAgain === 'true') {
          onConfirm();
          return;
        }
      }
      openModal(e);
    },
    [onConfirm],
  );

  const renderConfirmationModal = (isLoading: boolean, isError: boolean, isSuccess: boolean) => {
    return (
      isOpen &&
      renderModal({
        title,
        bodyExtras: { isLoading, isError, isSuccess },
        onRenderBody: (bodyExtras?: ModalBodyExtras) => {
          return <div>{content}</div>;
        },
        onRenderFooter: (onHide?: () => void, bodyExtras?: ModalBodyExtras) => {
          return (
            <>
              {isShowDoNotShowAgain && (
                <span className="gcl-gems-confirmation-modal-footer-not-show-again">
                  <Checkbox
                    checked={isSelectedModalNotShowAgain}
                    id="gcl-gems-confirmation-not-show-again"
                    onChange={(checked: boolean) => {
                      setIsSelectModalNotShowAgain(checked);
                    }}
                  />{' '}
                  Don&apos;t show again
                </span>
              )}
              <span>
                <LoadingButton
                  type={ComponentType.Primary}
                  onClick={() => {
                    if (isShowDoNotShowAgain && modalId)
                      localStorage.setItem(modalId, isSelectedModalNotShowAgain.toString());

                    onConfirm();
                    if (onHide) {
                      onHide();
                    }
                  }}
                  isLoading={bodyExtras?.isLoading}
                  isError={bodyExtras?.isError}
                  isSuccess={bodyExtras?.isSuccess}
                  timeToResetSuccessState={3000}
                  timeToResetErrorState={5000}
                  prefixIconName="FolderCheck"
                >
                  Confirm
                </LoadingButton>
                {isShowCancelBtn && (
                  <Button
                    prefixIconName="ChevronLeft"
                    type={ComponentType.Secondary}
                    onClick={() => {
                      if (onCancel && typeof onCancel === 'function') onCancel();
                      if (onHide) {
                        onHide();
                      }
                    }}
                    style={{ margin: '10px' }}
                  >
                    Cancel
                  </Button>
                )}
              </span>
            </>
          );
        },
      })
    );
  };
  return { openPortal, closePortal, renderModal: renderConfirmationModal };
};
